export const canEditEtapa = () => localStorage.getItem('podeeditaretapa')=="true"?true:false;

  
export const canEditProfile = () => localStorage.getItem('podeeditarperfil')=="true"?true:false;
 